<div class="p-fluid">
  @if (!canDelete) {
    <div class="field">
      <p-selectButton
        [options]="mainSmsOptions"
        [(ngModel)]="sms.type"
        (ngModelChange)="changeType()"
        styleClass="shadow-none">
      </p-selectButton>
    </div>
  }

  <div class="field">
    <label class="font-medium required-field">Имя отправителя</label>
    <crm-input-text
      [(value)]="sms.sender"
      class="w-full"
      [isError]="$any(errors?.sender)"></crm-input-text>
    @if (errors?.sender) {
      <small class="p-error">
        {{ errors.sender | join }}
      </small>
    }
  </div>

  @if (sms.type === MainSmsIntegrationTypeEnum.SMS) {
    <div class="field">
      <label class="font-medium required-field">Проект</label>
      <crm-input-text
        [(value)]="sms.project"
        class="w-full"
        [isError]="$any(errors?.project)"></crm-input-text>
      @if (errors?.project) {
        <small class="p-error">
          {{ errors.project | join }}
        </small>
      }
    </div>

    <div class="field">
      <label class="font-medium required-field">API-key</label>
      <crm-input-text
        [(value)]="sms.apiKey"
        class="w-full"
        [isError]="$any(errors?.apiKey)"></crm-input-text>
      @if (errors?.apiKey) {
        <small class="p-error">
          {{ errors.apiKey | join }}
        </small>
      }
    </div>
  }

  @if (sms.type === MainSmsIntegrationTypeEnum.EMAIL) {
    <div class="field">
      <label class="font-medium required-field">Почты</label>
      <p-chips
        [(ngModel)]="sms.emails"
        [addOnBlur]="true"
        [allowDuplicate]="false"
        [class]="errors?.emails ? ' ng-invalid ng-dirty' : ''"
        [styleClass]="errors?.emails ? ' ng-invalid ng-dirty' : ''"
        separator=","
        placeholder="test@mail.ru, test2@ya.ru"></p-chips>
      @if (errors?.emails) {
        <small class="p-error">
          {{ errors.emails | join }}
        </small>
      }
    </div>

    <div class="field">
      <label class="font-medium required-field">API-key</label>
      <crm-input-text
        [(value)]="sms.mailingApiKey"
        class="w-full"
        [isError]="$any(errors?.mailingApiKey)"></crm-input-text>
      @if (errors?.mailingApiKey) {
        <small class="p-error">
          {{ errors.mailingApiKey | join }}
        </small>
      }
    </div>
  }
</div>

<div class="mt-2">
  <div
    class="flex flex-wrap gap-3"
    [class.justify-content-center]="!canDelete"
    [class.justify-content-between]="canDelete">
    @if (!canDelete) {
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        style="min-width: 120px !important; max-width: 120px !important"
        (onClick)="onSave(sms)"></crm-button>
    }

    @if (canDelete) {
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="onSave(sms)"></crm-button>

      <crm-button
        label="Удалить"
        styleClass="p-button-danger p-button-text"
        (onClick)="delete.emit(sms)"></crm-button>
    }
  </div>
</div>
